import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from "reactstrap";

import Breadcrumbs from '../../components/Common/Breadcrumb';
import "../../assets/scss/datatables.scss"
import Moment from 'moment';
import { BaseUrl } from "../../helpers/Baseurl"
import { Link } from "react-router-dom"


class ActivityLog extends Component {
    constructor(props) {
        super(props);
        this.obj = this.props.obj

        this.state = {
            Activity_log:[],
            count:0,
            page_size:3,
        }
        this.handleLoadMore = this.handleLoadMore.bind(this);
    }   

    componentDidCatch(error) {
        console.log(error)
    }

    async componentDidMount() { 
        this.loadItineraryLogs(`?hotel__id=${this.props.hotel.id}&size=${this.state.page_size}`)  

    }

    async loadItineraryLogs(filter_data){

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json',},
        };
        await fetch(`${BaseUrl}/api/activity-log/hotel-logs/${filter_data}`,requestOptions)
            .then(res => res.json())
            .then(
                (data) => {   
                    this.setState({ Activity_log: data.results, count: data.count, loading:false })          
                    
                },
                (error) => {
                    console.log(error, 'error--------------') 
                }
            )  
    }

    handleLoadMore(){
        const { count, page_size } = this.state
        if(page_size+3 < count){
            this.setState({ page_size:page_size+3, loading:true})
            this.loadItineraryLogs(`?hotel__id=${this.props.hotel.id}&size=${page_size+3}`)
        }else{
            this.loadItineraryLogs(`?hotel__id=${this.props.hotel.id}&size=${count}`)
            this.setState({ page_size:count, loading:true})

        }
    }

    render() {
        const { Activity_log, count, loading, page_size } = this.state
        return (
            <React.Fragment key={"activity-Detail"}>
                <Breadcrumbs title="Activity Log" breadcrumbItems={[]} /> 
                
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardBody>
                                
                                {Activity_log.map((log) => {
                                   return  (
                                    
                                    <p><b>Changed By: </b> {log.user.email} at {Moment(new Date(log.datetime)).format("DD-MM-YYYY h:mm:ss A")}</p>
                                )})}
                                {this.props.hotel.created_by?
                                <p><b>Created By: </b> {this.props.hotel.created_by.email}</p>:null}
                                {loading?
                                    <Link to="#" className="text-primary">
                                        <i className="mdi mdi-loading mdi-spin font-size-20 align-middle me-2"></i>{" "}
                                        Loading{" "}
                                    </Link>
                                :null}

                                {page_size !== count && count > 3 && !loading? 
                                <Link to="#" onClick={() => this.handleLoadMore()} className="text-primary">
                                    Load more
                                </Link>:null}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </React.Fragment>
            
        );
    }
}

export default ActivityLog;